import React, { useContext } from 'react';

import { app, media } from 'context';
import { Grid, Icon, Img, Layout, Link, Text } from 'ds';
import { OFFICE_REQUEST_PATH } from 'routes';

interface Props {}

const OneStopShop: React.FC<Props> = () => {
  const { isMobile, md } = useContext(media);
  const { contentPaddingX } = useContext(app);

  const serviceItems = [
    {
      icon: 'sparkle',
      rotateIcon: false,
      title: 'AI office assistant',
      description: 'Automate office operations powered by AI and our (human) support team.'
    },
    {
      icon: 'wifi',
      rotateIcon: false,
      title: 'IT & internet',
      description: 'Professional IT and A/V services, including setup, equipment, and ongoing support.'
    },
    {
      icon: 'chair',
      rotateIcon: false,
      title: 'Furniture & design',
      description: 'From layout design to installation, we turn your office into a space your team will love.'
    },
    {
      icon: 'beverage',
      rotateIcon: false,
      title: 'Beverages & snacks',
      description: 'Refreshments and supplies, automatically restocked. Curated to your preferences.'
    },
    {
      icon: 'featherDuster',
      rotateIcon: true,
      title: 'Cleaning',
      description: 'Professional cleaning services on your schedule. Book services instantly.'
    },
    {
      icon: 'users',
      rotateIcon: false,
      title: 'Vendor network',
      description: 'Access our trusted network of service providers — with exclusive discounts.'
    }
  ];

  return isMobile ? (
    <Layout>
      <Layout position="relative" justify="center" align="center">
        <Img
          srcKey="home-page-one-stop-shop_yLg9k4s_w.jpg"
          folder="public"
          alt="office"
          width={342}
          style={{
            borderRadius: 16,
            maxWidth: 342
          }}
        />
      </Layout>
      <Layout paddingX={contentPaddingX} marginTop={64}>
        <Text size="headline-lg" color="blue-500">
          The one-stop-shop for your office needs
        </Text>
      </Layout>
      <Layout paddingX={contentPaddingX} marginTop={32}>
        <Text size="body-md" color="gray-400">
          Select the service packages you need to get your best work done.
        </Text>
      </Layout>
      <Layout paddingX={contentPaddingX} marginTop={32}>
        <Link href={OFFICE_REQUEST_PATH}>
          <Layout align="center">
            <Text size="body-md" color="blue-500" semibold>
              Get started
            </Text>
            <Layout marginLeft={8} display="inline-flex">
              <Icon name="rightArrow" color="blue-500" size="sm" stroke={2} />
            </Layout>
          </Layout>
        </Link>
      </Layout>
      <Layout paddingY={64} paddingX={contentPaddingX} direction="row" gap={16} overflow="auto" maxWidth="100vw">
        {serviceItems.map(item => (
          <Layout
            color="white"
            boxShadow="2px 0px 22px rgba(87, 73, 109, 0.12)"
            paddingX={24}
            paddingY={36}
            borderRadius={16}
            width={212}
            height={240}
            flexShrink={0}
          >
            <Layout transform={item.rotateIcon ? 'rotate(180deg)' : ''} width={32} height={32}>
              <Icon name={item.icon as any} size="xl" color="blue-500" />
            </Layout>
            <Layout marginY={16}>
              <Text size="body-md" color="blue-500" semibold>
                {item.title}
              </Text>
            </Layout>
            <Text color="gray-400" size="body-sm">
              {item.description}
            </Text>
          </Layout>
        ))}
      </Layout>
    </Layout>
  ) : (
    <Layout position="relative">
      <Img
        srcKey="home-page-one-stop-shop_yLg9k4s_w.jpg"
        folder="public"
        alt="office"
        width={1600}
        style={{
          borderRadius: 16,
          maxWidth: md ? 460 : 514,
          height: md ? 380 : 500,
          objectFit: 'cover',
          position: 'absolute',
          right: 0,
          top: 0,
          zIndex: 0
        }}
      />
      <Layout zIndex={1} position="relative">
        <Layout maxWidth={490}>
          <Text size="display-sm" color="blue-500">
            The one-stop-shop for your office needs
          </Text>
          <Layout marginTop={32}>
            <Text color="gray-400" size="body-md">
              Select the service packages you need to get your best work done.
            </Text>
          </Layout>
          <Layout marginTop={32}>
            <Link href={OFFICE_REQUEST_PATH}>
              <Layout align="center">
                <Text size="body-sm" color="blue-500" semibold>
                  Get started
                </Text>
                <Layout marginLeft={8} display="inline-flex">
                  <Icon name="rightArrow" color="blue-500" size="sm" stroke={2} />
                </Layout>
              </Layout>
            </Link>
          </Layout>
        </Layout>
        <Layout marginTop={36} maxWidth={668}>
          <Grid itemsPerRow={3} gapX={16} gapY={16}>
            {serviceItems.map(item => (
              <Layout
                color="white"
                boxShadow="2px 0px 22px rgba(87, 73, 109, 0.12)"
                paddingX={24}
                paddingY={36}
                borderRadius={16}
              >
                <Layout transform={item.rotateIcon ? 'rotate(180deg)' : ''} width={32} height={32}>
                  <Icon name={item.icon as any} size="xl" color="blue-500" />
                </Layout>
                <Layout marginY={16}>
                  <Text size="body-md" color="blue-500" semibold>
                    {item.title}
                  </Text>
                </Layout>
                <Text color="gray-400" size="body-sm">
                  {item.description}
                </Text>
              </Layout>
            ))}
          </Grid>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default OneStopShop;
